<template>
  <div v-if="chromeWarning && isPC" class="chrome-warning-container">
    <div class="label">
      你当前使用的浏览器无法获得最佳使用体验, 可切换到Chrome浏览器(谷歌浏览器)获得最佳体验
    </div>
    <div class="btnGrp">
      <el-button class="btn" size="medium" @click="close">
        知道了
      </el-button>
      <el-button type="primary" size="medium" @click="toDownLoad">
        下载Chrome
      </el-button>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';

// 查询当前操作系统类型
const os = (function () {
  const ua = navigator.userAgent;
  const isWindowsPhone = /(?:Windows Phone)/.test(ua);
  const isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone;
  const isAndroid = /(?:Android)/.test(ua);
  const isFireFox = /(?:Firefox)/.test(ua);
  const isChrome = /(?:Chrome|CriOS)/.test(ua);
  const isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua));
  const isPhone = /(?:iPhone)/.test(ua) && !isTablet;
  const isPC = !isPhone && !isAndroid && !isSymbian;
  return {
    isTablet,
    isPhone,
    isAndroid,
    isPC,
    isChrome,
  };
}());

export default {
  name: 'ChromeWarning',
  data() {
    return {
      isChrome: false,
      isShow: true,
      isPC: true,
    };
  },
  computed: {
    ...mapState({
      chromeWarning: state => state.common.chromeWarning,
    }),
  },
  created() {
    const UA = window.navigator.userAgent;
    this.isChrome = UA.indexOf('Chrome') >= 0;
    this.SET_CHROME_WARNING(!this.isChrome);

    this.isPC = os.isPC;
  },
  methods: {
    ...mapMutations('common', [
      'SET_CHROME_WARNING',
    ]),
    close() {
      this.isShow = false;
      this.SET_CHROME_WARNING(false);
    },
    toDownLoad() {
      window.open('https://www.google.cn/intl/zh-CN/chrome/', '_blank');
    },
  },
};
</script>
<style lang="less" scoped>
.chrome-warning-container {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 61px;
  width: 100%;
  background-color: rgba(0,0,0,0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  .label {
    line-height: 32px;
    font-size: 16px;
    color: white;
    font-family: "PingFangSC-Regular";
  }
  .btnGrp {
    margin-left: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    .btn {
      background-color: transparent;
      color: #FFFFFF;
    }
  }
}

</style>
